"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * API V1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.CampaignConfirmationToJSON = exports.CampaignConfirmationFromJSONTyped = exports.CampaignConfirmationFromJSON = exports.instanceOfCampaignConfirmation = void 0;
var runtime_1 = require("../runtime");
var CampaignConfirmationCampaign_1 = require("./CampaignConfirmationCampaign");
var CampaignConfirmationIndividual_1 = require("./CampaignConfirmationIndividual");
var CampaignConfirmationOrganizer_1 = require("./CampaignConfirmationOrganizer");
/**
 * Check if a given object implements the CampaignConfirmation interface.
 */
function instanceOfCampaignConfirmation(value) {
    var isInstance = true;
    return isInstance;
}
exports.instanceOfCampaignConfirmation = instanceOfCampaignConfirmation;
function CampaignConfirmationFromJSON(json) {
    return CampaignConfirmationFromJSONTyped(json, false);
}
exports.CampaignConfirmationFromJSON = CampaignConfirmationFromJSON;
function CampaignConfirmationFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'campaign': !(0, runtime_1.exists)(json, 'campaign') ? undefined : (0, CampaignConfirmationCampaign_1.CampaignConfirmationCampaignFromJSON)(json['campaign']),
        'organizer': !(0, runtime_1.exists)(json, 'organizer') ? undefined : (0, CampaignConfirmationOrganizer_1.CampaignConfirmationOrganizerFromJSON)(json['organizer']),
        'individual': !(0, runtime_1.exists)(json, 'individual') ? undefined : (0, CampaignConfirmationIndividual_1.CampaignConfirmationIndividualFromJSON)(json['individual']),
    };
}
exports.CampaignConfirmationFromJSONTyped = CampaignConfirmationFromJSONTyped;
function CampaignConfirmationToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'campaign': (0, CampaignConfirmationCampaign_1.CampaignConfirmationCampaignToJSON)(value.campaign),
        'organizer': (0, CampaignConfirmationOrganizer_1.CampaignConfirmationOrganizerToJSON)(value.organizer),
        'individual': (0, CampaignConfirmationIndividual_1.CampaignConfirmationIndividualToJSON)(value.individual),
    };
}
exports.CampaignConfirmationToJSON = CampaignConfirmationToJSON;
